import { DesktopDateTimePicker, DesktopDateTimePickerProps } from '@mui/x-date-pickers';
import React from 'react';
import { CustomDay } from './CustomDay';

export type MyDateTimePickerProps = Omit<DesktopDateTimePickerProps<Date>, 'slots' | 'slotProps'>;
export const CustomDateTimePicker: React.FC<MyDateTimePickerProps> = ({ value, onChange, ...rest }) => {
  return (
    <DesktopDateTimePicker
      label="Datum"
      value={value}
      format="dd.MM.yyyy HH:mm"
      onChange={onChange}
      slots={{
        day: CustomDay
      }}
      {...rest}
      slotProps={{
        desktopPaper: {
          sx: {
            '.MuiDateCalendar-root': {
              width: 270
            },

            '.MuiList-root.MuiMultiSectionDigitalClockSection-root': {
              width: 40
            },

            '.MuiButtonBase-root.MuiMenuItem-root.MuiMultiSectionDigitalClockSection-item': {
              width: 30,
              fontSize: 14,
              px: 1.25
            }
          }
        }
      }}
    />
  );
};
